import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7obrop9nhx: FaireBrandEntity = {
  token: "b_7obrop9nhx",
  type: "brand",
  name: "Calla Products",
  avatarUrl:
    "https://cdn.faire.com/fastly/300fcbfc888cc62e7dd159d44b0770f8603ca209bf4d52fe9062ec5c974a0d13.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/1f93fd00b77e6e8b7d0f6727dd07d5e6b570a86c1fb8209b6ad0a8feb3b0d6fa.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/300fcbfc888cc62e7dd159d44b0770f8603ca209bf4d52fe9062ec5c974a0d13.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/1f93fd00b77e6e8b7d0f6727dd07d5e6b570a86c1fb8209b6ad0a8feb3b0d6fa.jpeg",
  location: "Danville, CA, USA",
  minimumOrderDollars: 99,
  rating: 4.8,
  reviewCount: 38,
  isTopShop: true,
  isInsider: true,
  description:
    "Located in Northern California, Calla Products is dedicated to bringing innovative products to the market that are both functional and stylish.  Under the umbrella of Calla products, we have several brands including Nufoot, Nupouch, and Cali bags. Nufoot was created to solve the problem of what footwear to wear indoors.  Many people like to use socks for a barefoot feel, but they provide little protection from spills and germs.  Slippers provide more protection, but are heavy and bulky. The four-way stretch, neoprene construction of Nufoot gives you both protection and a true barefoot feel, the best of both worlds.   Nufoot is ideal for your workout, yoga, work from home meetings, and your boundless travels.  Available in dozens of styles and colors, Nufoot is the ideal indoor footwear. Nupouch is a line of functional and stylish bags designed for your every day adventure. All of our bags and accessories have features built into it that makes your life easier and protects your valuables better, in sleek and simple designs. Cali brand of bags add the feminine touch to our bags, making them great for day trips as well as evening around town. Shop all of our great designs at Calla Products!",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:07.481Z",
    importedBy: "entity-db-cli",
  },
};
